import PropTypes from 'prop-types';
import React, { createContext, useContext, useEffect } from 'react';

// material-ui
import { styled } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
// assets
import { AppBar, Button, Dialog, Divider, IconButton, ListItemText, ListItemButton, List, Slide, Toolbar, Typography, TextField, FormControl, Select, MenuItem, InputLabel } from '@mui/material';

// import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
// import Components from 'Components';
// import Action from 'store/Action';
import { toast } from 'react-toastify';
import ApiCall from '../../utils/Api';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuDialogContent-root': {
    padding: theme.spacing(2),
    
  },
  '& .MuDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const BootstrapDialogTitle = ({ children, onClose, ...other }) => (
  <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
    {children}
    {onClose ? (
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 10,
          color: "white"
        }}
      >
        {/* <CloseIcon /> */}
      </IconButton>
    ) : null}
  </DialogTitle>
);

BootstrapDialogTitle.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
};

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} timeout={1000} />);
export default function Status({updateCount,setupdateCount,id}) {
  const [status, setstatus] = React.useState();


  const [open, setOpen] = React.useState(false);
//   const Site_id = useSelector((state) => state.Booking.Site_id);
const updateData=async()=>{
  try {
    console.log("Checkkkk================================>>");
    const data = await ApiCall.SECURE_API.put(`/admin/editProvider/${id}`,{
      "status" : status,
  })
  if(data.data.success){
    toast.success("Status Updated Successfully");
  }
    console.log("🚀 ~ updateData ~ data=================:", data)
  handleClose()
  setupdateCount(updateCount+1)
  } catch (error) {
    console.log("🚀 ~ updateData ~ error:", error)
    
  }
    }
  // const onSubmit = async() =>{
  //   try {


   

  //    //  setupdateCount(updateCount+1)
  //    //  Action.AlertBox.Show(false);
  //    toast.success("Profile updated successfully");
  //     handleClose()
      
  //   } catch (error) {
  //    //  Action.AlertBox.Show(false)
  //     if (error?.response?.data?.message) {
  //       toast.error(error.response.data.message);
  //     } else {
  //       toast.error(error.message);
  //     }
  //     console.error("Error submitting data:", error);
  //   }
  // }
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };



  return (
    <div>
      <Button style={{ }} variant="outlined" onClick={handleClickOpen}>
        Edit
      </Button>
      <BootstrapDialog
        fullWidth="sx"
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}      >
        <BootstrapDialogTitle
          sx={{ position: 'relative', color: 'black',fontSize:20 }}
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Status
        </BootstrapDialogTitle>
        <DialogContent dividers>
        <div style={{}}>
           
               
            <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly",width:"100%"}}>
                     
                        <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                        <FormControl style={{ width: "90%" }} >
                                        <InputLabel id="demo-simple-select-label">Select</InputLabel>
                                        <Select
                                             labelId="demo-simple-select-label"
                                             id="demo-simple-select"
                                             value={status}
                                             label="Select"
                                             onChange={(e) => setstatus(e.target.value)}
                                             name='Instrumente'
                                        >
                                             <MenuItem value="">Unselect</MenuItem>
                                             <MenuItem value="true">White listed</MenuItem>
                                             <MenuItem value="false">Black listed</MenuItem>
                                             

                                        </Select>
                                   </FormControl>
                        </div>
                 </div>
        
           
               
               

            
      </div> 

        </DialogContent>
        <DialogActions>
          <Button style={{ }} onClick={updateData} autoFocus >
            SAVE
          </Button>
          <Button style={{ }} onClick={handleClose} autoFocus >
            Cancel
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
